// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1zD-z","messages":"Chat_messages__1cK2X","dateDivider":"Chat_dateDivider__ip31l"};